<div class="row">
  <div class="col">

    <div class="box box-primary">

      <div class="box-body">
        <nav class="navbar navbar-expand-lg navbar-light bg-light pr-1">
          <span class="navbar-brand"><i class="lnr-cog"></i></span>
          <button class="navbar-toggler" type="button"> </button>
          <div class="collapse navbar-collapse tabs-animated tabs-animated-shadow" id="navbarNav">
            <ul class="navbar-nav mr-auto">
              <li class="nav-item mr-2">
                <button class="btn-shadow btn" [ngClass]="{'btn-primary' : isNovoCadastro}" type="button"
                  [routerLink]="['cadastrar', '']">
                  <i class="fa fa-plus mr-2"></i> Cadastro SS
                </button>
              </li>

              <li class="nav-item">
                <button class="btn-shadow btn" type="button" [ngClass]="{'btn-primary' :!isNovoCadastro}"
                  routerLink="lista">
                  <i class="fa fa-list mr-2"></i> Lista de SSs
                </button>
              </li>
            </ul>
          </div>
        </nav>

        <router-outlet></router-outlet>

      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col">
    <div class="box box-primary">
      <div class="box-body">
        <div class="row">
          <div class="col">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq.png" /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>